module.exports = __webpack_public_path__ + "static/media/custom-table-d-TR11.2561f1f9.png";